import { OrderCartItem } from "../../types";

const OrderItemRecapCard: React.FC<{ item: OrderCartItem }> = ({ item }) => {
  const renderedModifierGroups = item.modifierGroups.map((modGroupElem) => {
    if (modGroupElem.modifierOptions?.length) {
      const renderedModifierOptions = modGroupElem.modifierOptions.map(
        (modOptionElem) => {
          return (
            <div
              key={modOptionElem.modifierOptionId}
              className="text-gray-500 text-xs ml-2"
            >
              {`+ ${modOptionElem.title} x${modOptionElem.quantity}`}
              {modOptionElem.price.value > 0 &&
                ` (${modOptionElem.price.text})`}
            </div>
          );
        }
      );

      return (
        <div
          key={modGroupElem.modifierGroupId}
          className="flex flex-col mt-1"
        >
          <div className="text-xs font-semibold text-gray-600">
            {modGroupElem.title} :
          </div>
          {renderedModifierOptions}
        </div>
      );
    }
    return null;
  });

  return (
    <div className="flex gap-4 py-3 border-b border-gray-100 last:border-0">
      <div className="flex-1 flex flex-col">
        <div className="flex justify-between items-start">
          <span className="font-semibold text-gray-800">{item.title}</span>
          <span className="font-semibold text-gray-800">
            {item.price.totalPrice.text}
          </span>
        </div>
        <div className="text-sm mt-1"> {renderedModifierGroups} </div>
      </div>
    </div>
  );
};

export default OrderItemRecapCard;
